import { SipRegistrationStatus } from '../../../types/did/did.type';
import { CURRENT_STATUS } from '../../../utils/constants';
import CurrentStatusDot from '../CurrentStatusDot/CurrentStatusDot';

export const sipRegistrationStatusToString = (status: SipRegistrationStatus): string => {
  switch (status) {
    case SipRegistrationStatus.Registered:
      return 'Registered';
    case SipRegistrationStatus.Unregistered:
      return 'Unregistered';
    case SipRegistrationStatus.Unknown:
      return 'Unknown';
  }
};

export const sipRegistrationStatusToCurrentStatus = (status: SipRegistrationStatus): number => {
  switch (status) {
    case SipRegistrationStatus.Registered:
      return CURRENT_STATUS.ONLINE;
    case SipRegistrationStatus.Unregistered:
      return CURRENT_STATUS.OFFLINE;
    case SipRegistrationStatus.Unknown:
      return CURRENT_STATUS.UNDEFINED;
  }
};

type SipRegistrationStatusDotProps = {
  status: SipRegistrationStatus;
};

const SipRegistrationStatusDot = ({ status }: SipRegistrationStatusDotProps) => {
  return (
    <CurrentStatusDot
      value={sipRegistrationStatusToCurrentStatus(status)}
      tooltipTitle={sipRegistrationStatusToString(status)}
    />
  );
};

export default SipRegistrationStatusDot;
